import { translate } from '../translate'
import * as texts from '../translateGenericText'

export const intl = { translate, texts }

export const useIntl = () => intl
